import React from 'react';

import { InvalidOrderStatusWrapper, TextContainer } from './styles';
import useConfigsStore from '../../store/configsStore';

export default function InvalidOrderStatus() {
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  return (
    <InvalidOrderStatusWrapper fontFamily={devolutionPageConfigs?.fontFamily}>
      <TextContainer>
        Pedido já processado. O método de devolução já foi selecionado!
        <br />
        <br />
        Em caso de dúvidas consulte o lojista para mais detalhes.
      </TextContainer>
    </InvalidOrderStatusWrapper>
  );
}
